module.exports = __webpack_public_path__ + "static/media/fslogo.b9afa863.png";